import React from 'react'
import SearchResultDataTable from '../SearchResultDataTable/SearchResultDataTable'
import SearchResultCardGrid from '../SearchResultCardGrid'
import ItemSearchModal from '../AddItemToListModal/AddItemToListModal'
import {SearchPagination} from '../../../searchPagination/SearchPagination'
import {ItemList} from '../../../../itemList/model/ItemList'
import {FullSearchResult} from '../../useFullSearch'
import SearchToolBarForItemSearch from '../SearchToolBar/SearchToolBarForItemSearch'

const emptyArray: any[] = []

export const SearchResultTableForItemList = ({
                                                 currentList,
                                                 fullSearchResult
                                             }: {
    currentList: ItemList | null,
    fullSearchResult: FullSearchResult
}) => {
    const {
        searchResult,
        searchFilters,
        search,
        searchResultControl: {
            legacyView,
            addToMultiSelect,
            removeFromMultiSelect,
            handleAddSingleItemToList,
            isSelected,
            pageSize,
            addItemsToListModalVisible,
            setAddItemsToListModalVisible,
            selectedItemIds,
            handleRowSelectionChange,
        },
        page,
        handlePageChange,
        isSearchFetching,
        fullSearchParams
    } = fullSearchResult

    const itemIds = Array.from(selectedItemIds).map(id => String(id))

    return (
        <div>
            <div className="search-results-table">
                <SearchToolBarForItemSearch
                    fullSearchResult={fullSearchResult}
                    currentList={currentList}
                />
                {!legacyView && (
                    <SearchResultDataTable
                        definitionsToDisplay={searchResult?.definitionsToDisplay ?? []}
                        list={searchResult?.elements ?? emptyArray}
                        handleAddSingleItemToList={handleAddSingleItemToList}
                        highlightPhrase={search?.phrase?.phraseDetail ?? ''}
                        showAddToListButton={false}
                        selectedItems={selectedItemIds}
                        handleRowSelectionChange={handleRowSelectionChange}
                        enableColumFiltering={true}
                        isLoading={isSearchFetching}
                        filterValues={searchFilters}
                        fullSearchParams={fullSearchParams}
                    />
                )}
                {legacyView && (
                    <SearchResultCardGrid
                        searchItems={searchResult?.elements ?? []}
                        addToMultiSelect={(item) => addToMultiSelect([item])}
                        removeFromMultiSelect={removeFromMultiSelect}
                        handleAddSingleItemToList={handleAddSingleItemToList}
                        isSelected={isSelected}
                        highlightPhrase={search?.phrase?.phraseDetail ?? ''}
                        isMultiSelectionEnabled={true}
                        displayAddToListButton={false}
                    />
                )}
            </div>
            <SearchPagination
                totalElements={searchResult?.totalElements || 0}
                pageSize={pageSize}
                page={page}
                handlePageChange={handlePageChange}
            />
            {addItemsToListModalVisible && (
                <ItemSearchModal
                    closeModal={() => setAddItemsToListModalVisible(false)}
                    itemIds={itemIds}
                />
            )}
        </div>
    )
}
